module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.routes), function(route, index) {
    return (route.type == _vm.routeType) ? _c('div', {
      staticClass: "panel p-2 mt-2"
    }, [_c('div', {
      staticClass: "py-0 font-weight-600 d-flex"
    }, [_c('div', {
      staticClass: "activeHover col-sm-8 d-flex align-items-center"
    }, [_c('i', {
      staticClass: "ico mr-2 ml-2 fs-normal pointer dark",
      class: {
        'ico-arrow-bottom': !route.expanded, 'ico-arrow-top': route.expanded
      },
      on: {
        "click": function($event) {
          return _vm.expandRoute(route)
        }
      }
    }), _vm._v(" "), (route.editingName) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (route.name),
        expression: "route.name"
      }],
      staticClass: "style-underline",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (route.name)
      },
      on: {
        "keyup": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.editRouteName(route)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(route, "name", $event.target.value)
        }
      }
    }) : _c('span', {
      staticClass: " pl-1 d-flex align-items-center"
    }, [_c('span', [_vm._v(_vm._s(route.name))])]), _vm._v(" "), _c('i', {
      staticClass: "ico ico-edit fs-normal pointer mx-2 dark",
      class: {
        'ico-edit': !route.editingName, 'ico-check': route.editingName, 'withHover': !route.editingName
      },
      on: {
        "click": function($event) {
          return _vm.editRouteName(route)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-4 text-right"
    }, [_c('i', {
      staticClass: "ico ico-notes mr-3 fs-normal pointer dark",
      on: {
        "click": function($event) {
          return _vm.duplicateRoute(_vm.routes, index)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "ico ico-delete m-0 fs-normal pointer dark",
      on: {
        "click": function($event) {
          return _vm.askDeleteRoute(_vm.routes, index)
        }
      }
    })])]), _vm._v(" "), (route.expanded) ? _c('div', {
      staticClass: "col-sm-12 mt-3 mb-1"
    }, [(route.iteneraries && route.iteneraries.length > 0) ? _c('table', {
      staticClass: "w-100"
    }, [_c('thead', [_c('tr', {
      staticClass: "lightest bg-dark"
    }, [_c('th', {
      staticStyle: {
        "width": "40px"
      }
    }, [_vm._v(" ")]), _vm._v(" "), _vm._m(0, true), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _vm._l((route.iteneraries[0].schedules), function(time, index) {
      return _c('th', {
        staticClass: "text-center activeHover",
        attrs: {
          "width": "100px"
        }
      }, [_c('span', {
        staticClass: "notHover"
      }, [_vm._v("Time " + _vm._s(index + 1) + " "), _c('i', {
        staticClass: "ico ico-delete fs-normal m-0"
      })]), _vm._v(" "), _c('span', {
        staticClass: "withHover"
      }, [_c('i', {
        staticClass: "ico ico-delete fs-normal pointer m-0",
        on: {
          "click": function($event) {
            return _vm.deleteTimeRow(route, index)
          }
        }
      })])])
    }), _vm._v(" "), _c('th', {
      staticClass: "text-center",
      attrs: {
        "width": "50px"
      }
    }, [_c('i', {
      staticClass: "ico ico-timer fs-normal pointer mr-0",
      on: {
        "click": function($event) {
          return _vm.addTimeToRoute(route)
        }
      }
    })]), _vm._v(" "), _c('th', {
      staticClass: "text-center",
      attrs: {
        "width": "20px"
      }
    }, [_vm._v(" ")])], 2)]), _vm._v(" "), _c('draggable', {
      staticClass: "w-100",
      attrs: {
        "options": _vm.draggableOptions,
        "element": 'tbody'
      },
      on: {
        "change": function($event) {
          return _vm.updateStopNr(route)
        }
      },
      model: {
        value: (route.iteneraries),
        callback: function($$v) {
          _vm.$set(route, "iteneraries", $$v)
        },
        expression: "route.iteneraries"
      }
    }, _vm._l((route.iteneraries), function(itinerary, index) {
      return _c('tr', {
        key: itinerary.id,
        staticClass: "stopRow w-100"
      }, [_c('td', {
        staticClass: "text-center overflowHidden"
      }, [_c('div', {
        staticClass: "routeMarker radius-circle"
      }, [_c('span', {
        staticClass: "fs-smaller radius-circle"
      }, [_vm._v(_vm._s(itinerary.order))])])]), _vm._v(" "), _c('td', {}, [_c('v-select', {
        staticClass: "w-100 d-inline-block align-middle",
        attrs: {
          "options": _vm.locationsList,
          "label": "name"
        },
        model: {
          value: (itinerary.stop),
          callback: function($$v) {
            _vm.$set(itinerary, "stop", $$v)
          },
          expression: "itinerary.stop"
        }
      })], 1), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (itinerary.note),
          expression: "itinerary.note"
        }],
        staticClass: "w-100",
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (itinerary.note)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(itinerary, "note", $event.target.value)
          }
        }
      })]), _vm._v(" "), _vm._l((itinerary.schedules), function(time) {
        return _c('td', {
          staticClass: "text-center"
        }, [_c('timepicker', {
          staticStyle: {
            "display": "inline-flex"
          },
          attrs: {
            "defaultTime": _vm.setTimeToPicker(time.time)
          },
          on: {
            "change": function($event) {
              return _vm.changeTime($event, time)
            }
          }
        })], 1)
      }), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        staticStyle: {
          "width": "70px"
        }
      }, [_c('span', {
        staticClass: "dark fs-smaller pointer",
        on: {
          "click": function($event) {
            return _vm.addTimeToRoute(route)
          }
        }
      }, [_c('i', {
        staticClass: "ico ico-add"
      }), _vm._v("Add hour")])]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_c('i', {
        staticClass: "ico ico-delete m-1 fs-normal pointer dark",
        on: {
          "click": function($event) {
            return _vm.removeStop(route.iteneraries, index)
          }
        }
      })])], 2)
    }), 0)], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 text-right my-3"
    }, [_c('button', {
      staticClass: "btn blue mr-3",
      on: {
        "click": function($event) {
          return _vm.addStop(route)
        }
      }
    }, [_vm._v("\n                    + New Location\n                ")]), _vm._v(" "), _c('button', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.saveRoute(route)
        }
      }
    }, [_vm._v("\n                    Save List\n                ")])])]) : _vm._e()]) : _vm._e()
  }), 0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_c('span', {
    staticClass: "pl-2"
  }, [_vm._v("Stop Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "auto"
    }
  }, [_c('span', {
    staticClass: "pl-2"
  }, [_vm._v("Info")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-f7f27e82", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f7f27e82"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/transports/RoutesHolder.vue
// module id = 1912
// module chunks = 0